import { createEnumParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { PersonReadModelSort, SortOrder } from '@client/api';

export const useUserListSearchQueryParams = () => {
  const result = useQueryParams({
    usersSearch: StringParam,
  });

  return result;
};

export const useUserListSortQueryParams = () => {
  const result = useQueryParams({
    usersSortProperty: withDefault<PersonReadModelSort | undefined | null, PersonReadModelSort>(
      createEnumParam(['Name', 'FirstName', 'LastName', 'Email']),
      'FirstName'
    ),
    usersSortOrder: withDefault<SortOrder | undefined | null, SortOrder>(createEnumParam(['Asc', 'Desc']), 'Asc'),
  });

  return result;
};
